module.exports = __webpack_public_path__ + "img/great-place-to-work-logo.2447a553.png";